import React from 'react';
import c from 'classnames';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

export interface CardProps {
  url: string;
  label?: string;
  labelIcon?: string;
  sublabel?: string;
  title: string | React.ReactElement;
  subtitle?: string;
  link?: string;
  linkText?: string;
  className?: string;
}

const Card: React.FC<CardProps> = (props) => {
  const {
    url,
    label,
    labelIcon,
    sublabel,
    title,
    subtitle,
    link,
    linkText,
    className,
  } = props;

  const classNames = c('Card', className);

  return (
    <article className={classNames}>
      {(label || sublabel) && (
        <header className="Card__header">
          {label && (
            <div className="Card__label">
              {labelIcon && <div className={`icon icon-variant-4 icon-${labelIcon}`} />}
              <span className="asLabel">{label}</span>
            </div>
          )}

          {sublabel && (
            <div className="Card__sublabel asLabel">
              {sublabel}
            </div>
          )}
        </header>
      )}

      <a href={url}>
        <h3 className="asH4 mt-1 mb-0  Card__title">{title}</h3>
      </a>

      {subtitle && (
        <WysiwygField
          className="asH5 mt-2 mb-0 Card__subtitle"
          property="schema:text"
          html={subtitle}
        />
      )}

      {(link && linkText) && (
        <a className="asH5 mt-2 link Card__link" href={link} target="_blank" rel="noreferrer noopener">
          {linkText}
        </a>
      )}
    </article>
  );
};

export default Card;
